<template>
  <section class="bg-gray-light">
    <div class="container">
      <div class="row my-3">
        <div class="col">
          <!-- <h1>{{ $t("translation.Contactez_Nous") }} :</h1> -->
          <p>
            {{ $t("translation.contact_txt") }}
          </p>
          <hr />
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <!-- <h4>{{ $t("translation.Nos_coordonnées") }}</h4> -->
          <p>
            <strong>Pieter van Naeltwijck Real Estate Investments </strong
            ><br />
            Le Park Palace<br />
            6 Impasse de la Fontaine<br />
            MC 98000 Monaco<br />
            {{ $t("translation.Tel") }}:
            <a href="tel:+37797707020">+377 97 70 70 20</a><br />
            Fax: +377 97 70 70 21<br />
          </p>
        </div>
        <div class="col-md-7 offset-md-1">
          <h4>{{ $t("translation.Pour_nous_envoyer_un_message") }} :</h4>
          <div class="row">
            <div class="col-md-12">
              <m-form-text
                :name="$Utils.randomstring('name')"
                v-model="newContact.name"
                :label="$t('translation.Nom')"
              ></m-form-text>
              <m-form-text
                :name="$Utils.randomstring('firstname')"
                v-model="newContact.firstname"
                :label="$t('translation.Prenom')"
              ></m-form-text>
              <m-form-select
                :name="$Utils.randomstring('country')"
                v-model="newContact.country"
                :label="$t('translation.Pays')"
                :items="[
                  { text: 'Monaco', value: 'Monaco' },
                  { text: 'France', value: 'France' },
                  { text: 'England', value: 'Angleterre' },
                  { text: 'Italia', value: 'Italie' },
                  { text: 'España', value: 'Espagne' },
                  { text: 'Россия', value: 'Russie' }
                ]"
              ></m-form-select>
              <m-form-text
                :name="$Utils.randomstring('email')"
                v-model="newContact.email"
                :label="$t('translation.Email')"
              ></m-form-text>
              <m-form-text
                :name="$Utils.randomstring('tel1')"
                v-model="newContact.tel"
                :label="$t('translation.Tel')"
              ></m-form-text>
              <m-form-text
                type="textarea"
                :rows="7"
                :name="$Utils.randomstring('message')"
                v-model="newContact.message"
                :label="$t('translation.Message')"
              ></m-form-text>
              <div class="row mb-3">
                <div class="col-md-12 d-flex flex-row justify-content-start">
                  <vue-recaptcha
                    ref="invisibleRecaptcha"
                    @verify="onVerify"
                    @expired="onExpired"
                    :sitekey="google_key"
                    :loadRecaptchaScript="true"
                    theme="light"
                  ></vue-recaptcha>
                </div>
              </div>
              <button
                class="w-100 btn btn-primary"
                type="button"
                @click="sendForm"
              >
                {{ $t("translation.Envoyer") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <m-message-dialog
      v-model="messageDialog"
      :title="messageDialogTitle"
      :text="messageDialogTxt"
    ></m-message-dialog>
  </section>
</template>

<script>
export default {
  name: "contactus",
  components: {},
  data() {
    return {
      newContact: {
        name: "",
        firstname: "",
        country: "",
        email: "",
        tel: "",
        message: ""
      },
      recaptcha: false,
      google_key: this.$config.google_key,
      messageDialog: false,
      messageDialogTitle: "",
      messageDialogTxt: ""
    };
  },
  mounted() {},
  methods: {
    async sendForm() {
      let requiredField = [
        {
          text: this.$t("translation.Prenom"),
          value: this.newContact.firstname
        },
        { text: this.$t("translation.Nom"), value: this.newContact.name },
        { text: this.$t("translation.Email"), value: this.newContact.email },
        { text: this.$t("translation.Tel"), value: this.newContact.tel },
        { text: this.$t("translation.Pays"), value: this.newContact.country },
        {
          text: this.$t("translation.Message"),
          value: this.newContact.message
        },
        {
          text: this.$t("translation.Je ne suis pas un robot"),
          value: this.recaptcha
        }
      ];
      // return console.log("this.row_co", this.row_co.firstname);
      let err = [];
      for (let ifield = 0; ifield < requiredField.length; ifield++) {
        const field = requiredField[ifield];
        if (!field.value) err.push(field);
      }
      if (err.length) {
        //alert("vous devez remplir tous les champs");
        this.messageDialog = true;
        this.messageDialogTxt =
          this.$t("translation.Vous devez remplir les champs") + " : <br/>";
        this.messageDialogTitle = this.$t("Erreur");
        for (let ierr = 0; ierr < err.length; ierr++) {
          const erreur = err[ierr];
          this.messageDialogTxt += erreur.text + "<br/>";
        }
        return;
      }
      let response = await this.$axios.post(
        this.$config.server_url + "/web/1.0/contactus",
        this.newContact
      );
      // console.log("response", response);
      if (response.data.err) {
        this.messageDialog = true;
        this.messageDialogTxt = this.$t(
          "Une erreur est survenue, votre message n'a pas pu être envoyé"
        );
        this.messageDialogTitle = this.$t("Erreur");
      }
      if (response.data.data && response.data.data.success) {
        this.messageDialog = true;
        this.messageDialogTxt = this.$t("Votre message a bien été envoyé");
        this.messageDialogTitle = this.$t("Confirmation");
        this.resetNewContact();
      }
    },
    onVerify: function(response) {
      this.recaptcha = true;
      // console.log("Verify: " + response);
    },
    onExpired: function() {
      //console.log("Expired");
      this.recaptcha = false;
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset(); // Direct call reset method
    },
    resetNewContact() {
      this.newContact = {
        name: "",
        firstname: "",
        country: "",
        email: "",
        tel: "",
        message: ""
      };
      this.resetRecaptcha();
    }
  }
};
</script>

<style lang="scss" scoped>
section {
  padding-bottom: 50px;
  padding-top: 40px;
}
</style>
